/* the cookout, event page. slider arrows and quantity steppers.
   Load with defer: <script src="{{ 'cookout-event.js' | asset_url }}" defer></script>
   Nothing here autoplays. */
(function () {
  function initSlider(root) {
    var slider = root.querySelector('.co-slider');
    var btns = root.querySelectorAll('.co-slider-btn');
    if (!slider || btns.length < 2) return;
    function step() {
      var card = slider.firstElementChild;
      return card ? card.offsetWidth + 14 : 214;
    }
    btns[0].addEventListener('click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
    btns[1].addEventListener('click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
    function sync() {
      btns[0].disabled = slider.scrollLeft < 8;
      btns[1].disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 8;
    }
    slider.addEventListener('scroll', sync);
    sync();
  }

  function initQty(qty) {
    var out = qty.querySelector('[data-qty-value]');
    var input = qty.querySelector('input[name="quantity"]');
    var btns = qty.querySelectorAll('button');
    var n = 1;
    function set(v) {
      n = Math.max(1, v);
      out.textContent = n;
      if (input) input.value = n;
    }
    btns[0].addEventListener('click', function () { set(n - 1); });
    btns[1].addEventListener('click', function () { set(n + 1); });
  }

  function initMenu(btn) {
    var root = btn.closest('.co-sec') || document;
    var panel = root.querySelector('[data-co-panel]');
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.setAttribute('data-open', String(!open));
    });
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('data-open', 'false');
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-co-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-co-qty]').forEach(initQty);
    (scope || document).querySelectorAll('[data-co-menu]').forEach(initMenu);
        (scope || document).querySelectorAll('[data-co-timecode]').forEach(function (el) {
      if (el.dataset.running) return;
      el.dataset.running = '1';
      var t = 0;
      setInterval(function () {
        t += 1;
        var h = String(Math.floor(t / 3600)).padStart(2, '0');
        var m = String(Math.floor(t / 60) % 60).padStart(2, '0');
        var s = String(t % 60).padStart(2, '0');
        el.textContent = h + ':' + m + ':' + s;
      }, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  /* theme editor re-renders a section without a full reload */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();